import React from 'react';

import { getEvent } from 'models/events';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	// 由於動態路由上 dev 會有問題, 故改成固定路由並且直接抓取固定的 query string
	path: '/event-info',
	components: () => [import(/* webpackChunkName: 'eventInfo' */ './component')],
	render: ([EventInfo]) => <EventInfo />,
	// 由於動態路由上 dev 會有問題, 故改成固定路由並且直接抓取固定的 query string
	onEnter: async ({ store, query }) => {
		console.log('on Enter Event Info Page');
		await store.dispatch(getEvent(Number(query.id)));
		console.log('on Enter Event Info Page / end');
	},
};

export default routes;
